<div class="navbar-container " [class]="isSidebarOpen() ? 'navbar-open' : '' ">
    <div class="backdrop">
    </div>
    <div class="desc-menu txt-link cursor-pointer" [class]="isSidebarOpen() ? '' : 'header-menu-centered'"
        (click)="toggleSidebar()"
        (keydown.enter)="toggleSidebar()"
        >
        {{ isSidebarOpen() ? "CHIUDI" : "MENU" }}
    </div>
    <div class="bb-custom">

    </div>

    @if(mergedMenu().length > 0) {
    @for (item of mergedMenu(); track item.id) {
    <div [title]="item.tooltip"  [routerLink]="item.link" class="menu-open-container">
        <div class="menu-section-container background-hover cursor-pointer br-blue" (keydown.enter)="isSidebarOpen() ? toggleSidebar(item) : null" (click)="isSidebarOpen() ? toggleSidebar(item) : null"
        >
            <div class="menu-item-wrapper d-flex">
                <div class="icon-wrapper cursor-pointer">
                    <img [src]="item.icon" alt="menu-icon">
                </div>
                <div class="accordion-container" [class.accordion-visible]="isSidebarOpen()"
                    [class.accordion-hidden]="!isSidebarOpen()">
                    <div class="container-tab-navigation">
                        <div class="desc-link fw-bold background-hover cursor-pointer" >
                            {{ item.label }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div>

    </div>
    }
    } @else {
    <div>
        MENU NON DISPONIBILE
    </div>
    }

</div>